import { useState } from 'react';
import type { WorkspaceData } from '@/shared/types/workspace';
import {
  type Agent,
  connectedAgent,
  type FirstRunPhase,
  initialPhase,
  stepNumber,
} from '../model/first-run';

type UseFirstRunResult = {
  phase: FirstRunPhase;
  agent: Agent;
  step: 1 | 2 | 3;
  isFinished: boolean;
  pickAgent: (agent: Agent) => void;
  toChoose: () => void;
  toConnect: () => void;
  toTest: () => void;
};

/** Where the three-step first run stands (design: FirstRun). */
export function useFirstRun(workspace: WorkspaceData): UseFirstRunResult {
  const [phase, setPhase] = useState<FirstRunPhase>(() => initialPhase(workspace.connections));
  const [agent, setAgent] = useState<Agent>(
    () => connectedAgent(workspace.connections) ?? 'claude-code',
  );
  const isFinished = workspace.latestTestPod?.status === 'PASSED';

  return {
    phase,
    agent,
    step: stepNumber(phase),
    isFinished,
    pickAgent: setAgent,
    toChoose: () => setPhase('choose'),
    toConnect: () => setPhase('connect'),
    toTest: () => setPhase('test'),
  };
}
